import React from "react";
import Header from "../Landingpagecomponents/Header/header";
import { Grid } from "@material-ui/core";
import Maincontent from "../Landingpagecomponents/Content/Maincontent"
import ClinicContent from "../Landingpagecomponents/Content/ClinicContent";
import RehabContent from "../Landingpagecomponents/Content/RehabContent";
import EldercareContent from "../Landingpagecomponents/Content/EldercareContent";
import Footer from "../Landingpagecomponents/Footer/Footer"

const LANDING_NAV_ITEMS = [
  { value: 'how-it-works', label: 'How it works', visible: false, contentValue: 0, scrollTargetId: 'landing-how-it-works' },
  { value: 'patients', label: 'Patients', visible: true, contentValue: 0 },
  { value: 'physios', label: "Physio's & insurances", visible: true, contentValue: 1 },
  { value: 'find-clinic', label: 'Find a clinic', visible: true, contentValue: 0, bookingPath: 'booking_first' },
  { value: 'rehab', label: 'Rehab', visible: false, contentValue: 2 },
  { value: 'eldercare', label: 'Eldercare', visible: false, contentValue: 3 },
  { value: 'insurance', label: 'Insurance', visible: false, contentValue: 1 },
];

function getLandingNavItem(navValue) {
  return LANDING_NAV_ITEMS.find((entry) => entry.value === navValue)
    || LANDING_NAV_ITEMS.find((entry) => entry.visible)
    || LANDING_NAV_ITEMS[0];
}

function getSafeLandingNavValue(navValue) {
  const navItem = getLandingNavItem(navValue);
  if (navItem && navItem.visible) {
    return navItem.value;
  }

  return LANDING_NAV_ITEMS.find((entry) => entry.visible)?.value ?? 'patients';
}




class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeNavValue: 'patients',
      headerVisible: true,
      lastScrollY: 0,
      patientBookingDialogOpen: false,
      patientBookingDialogPath: 'assessment_first',
      clinicSignupRequestKey: 0,
    };
    this.handleNavChange = this.handleNavChange.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleClosePatientBookingDialog = this.handleClosePatientBookingDialog.bind(this);
    this.openPatientBookingDialog = this.openPatientBookingDialog.bind(this);
    this.scrollToElement = this.scrollToElement.bind(this);
    this.handleOpenClinicSignup = this.handleOpenClinicSignup.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleInitialClinicSignupRequest();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleInitialClinicSignupRequest() {
    const search = this.props.location?.search || '';
    const params = new URLSearchParams(search);
    if (params.get('openClinicSignup') !== '1') {
      return;
    }

    this.setState((previous) => ({
      activeNavValue: 'physios',
      clinicSignupRequestKey: previous.clinicSignupRequestKey + 1,
    }));
  }

  handleScroll() {
    const currentScrollY = window.scrollY;
    if (currentScrollY > this.state.lastScrollY && currentScrollY > 50) {
      // Scrolling down
      if (this.state.headerVisible) {
        this.setState({ headerVisible: false });
      }
    } else if (currentScrollY < this.state.lastScrollY) {
      // Scrolling up
      if (!this.state.headerVisible) {
        this.setState({ headerVisible: true });
      }
    }
    this.setState({ lastScrollY: currentScrollY });
  }

  scrollToElement(elementId) {
    const scroll = () => {
      const target = document.getElementById(elementId);
      if (!target) {
        return false;
      }

      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    };

    if (!scroll()) {
      window.requestAnimationFrame(() => {
        if (!scroll()) {
          window.setTimeout(scroll, 120);
        }
      });
    }
  }

  openPatientBookingDialog(path = 'assessment_first') {
    this.setState({
      patientBookingDialogOpen: true,
      patientBookingDialogPath: path,
    });
  }

  handleClosePatientBookingDialog() {
    this.setState({ patientBookingDialogOpen: false });
  }

  handleOpenClinicSignup() {
    this.setState((previous) => ({
      activeNavValue: 'physios',
      patientBookingDialogOpen: false,
      patientBookingDialogPath: 'assessment_first',
      clinicSignupRequestKey: previous.clinicSignupRequestKey + 1,
    }), () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  handleNavChange(event, newValue) {
    const nextNavValue = getSafeLandingNavValue(newValue);
    const navItem = getLandingNavItem(nextNavValue);

    this.setState(
      {
        activeNavValue: nextNavValue,
        patientBookingDialogOpen: false,
        patientBookingDialogPath: 'assessment_first',
      },
      () => {
        if (navItem.scrollTargetId) {
          this.scrollToElement(navItem.scrollTargetId);
          return;
        }

        if (navItem.bookingPath) {
          this.openPatientBookingDialog(navItem.bookingPath);
          return;
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    );
  }

  renderContent(contentValue) {
    switch (contentValue) {
      case 0:
        return (
          <Maincontent
            bookingDialogOpen={this.state.patientBookingDialogOpen}
            bookingDialogPath={this.state.patientBookingDialogPath}
            onCloseBookingDialog={this.handleClosePatientBookingDialog}
            onOpenBookingDialog={this.openPatientBookingDialog}
            onShowClinicContent={() => this.handleNavChange(null, 'physios')}
          />
        );
      case 1:
        return <ClinicContent signupRequestKey={this.state.clinicSignupRequestKey} />;
      case 2:
        return <RehabContent />;
      case 3:
        return <EldercareContent />;
      default:
        return <Maincontent />;
    }
  }

  render() {
    const activeNavValue = getSafeLandingNavValue(this.state.activeNavValue);
    const activeNavItem = getLandingNavItem(activeNavValue);

    return (
      <Grid container direction="column" justify="center" >
        <Grid item justify="center" alignItems="center" style={{marginBottom: 0}} >
          <Header
            tabValue={activeNavValue}
            tabs={LANDING_NAV_ITEMS}
            onTabChange={this.handleNavChange}
            onOpenClinicSignup={this.handleOpenClinicSignup}
            visible={this.state.headerVisible}
          />
        </Grid>
        <Grid container xs={12} >
          <Grid container justify="center" padding={0} style={{marginTop: '0%', marginBottom: "0%"}} >
            <Grid item xs={12}
              style={{  marginTop: 2, paddingBottom: 75,
                height: 'auto', width: 'auto', maxHeight: "100%",
                background: `linear-gradient(90deg, #dce4eb, #d7d4cf)`,
                backgroundPosition: 'top',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}>
              {this.renderContent(activeNavItem.contentValue)}
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={0} md={2} lg={1} container style={{ backgroundColor: "dce4eb" }} />
        <Grid xs={12} container justify="center" justifyContent="center">
          <Footer />
        </Grid>
        <Grid xs={0} md={2} lg={1} container style={{ backgroundColor: "dce4eb" }} />
      </Grid>
    )
  }
}

export default LandingPage;


//render() {
//    return (
//      <div>
//        <section>
//          <header>
//            <img src="/src/Landingpagecomponents/images/logo.png" width="100" alt="logo" />
//            <div>
//              <ul>
//                <li>HOME</li>
//                <li>ABOUT</li>
//                <li>SERVICES</li>
//                <li>BLOG</li>
//              </ul>
//            </div>
//          </header>
//        </section>
//
//        <section id="main">
//          <div className="main-text">
//            <span>kindself.</span> <br /> where we reinvent <br />
//            the meaning of selfcare
//          </div>
//
//          <img src="./images/leaf.png" width="520" alt="leaf-main-image" />
//        </section>
//      </div>
//    );
//  }
//}